import { useContext } from 'react'
import { Context as FarmsContext } from '../../contexts/Farms'
import { MINTTOKEN } from '../../constants/bakery'

const useFarms = (tokenName?: string) => {
  const {
    bakeFarms,
    newFarms,
    endedFarms,
    otherFarms,
    allNftFarms,
    petFarms,
    bPetFarms,
    weaponFarms,
    bestFarms,
    helmetFarms,
    ethFarms,
    aethFarms,
    aethAndethFarms,
    springFarms,
    wsoteFarms,
    shieldFarms,
    bryFarms,
    bakeStakingFarms,
    defi100Farms,
    defi100OLDFarms,
    bananaFarms,
    seascapeNftFarms,
    pcwsFarms,
    warFarms,
    war2Farms,
    tkoNftFarms,
    dieselFarms,
    hatNftFarms,
    mxFarms,
    aliceFarms,
    aliceNftFarms,
    bondlyNftFarms,
    dfyFarms,
    gfxFarms,
    xDittoFarms,
    sactFarms,
    pet3Farms,
    hyfiFarms,
    ginuFarms,
    levFarms,
    bondlyFarms,
    tctFarms,
    tkoFarms,
    tkonftStakeFarms,
    bmoncnftStakeFarms,
    bmmnftStakeFarms,
    nftStakeFarms,
    oneInchBakeNftFarms,
    tko2Farms,
    bnrgFarms,
    tsaFarms,
    tlmFarms,
    xdittoNftFarms,
    doggyTlmFarms,
    barkTlmFarms,
    tokauTlmFarms,
    bondly2Farms,
    toynftStakeFarms,
    gatTlmFarms,
    bakeV2Farms,
    wsgFarms,
    dogoFarms,
    toyNftFarms,
    bethFarms,
    tokauFarms,
    eggFarms,
    kalataFarms,
    donFarms,
    ntFarms,
    moniFarms,
    kxaFarms,
    nblFarms
  } = useContext(FarmsContext)
  let farms
  switch (tokenName) {
    case MINTTOKEN.ALLNEW:
      farms = newFarms
      break
    case MINTTOKEN.ENDED:
      farms = endedFarms
      break
    case MINTTOKEN.OTHERS:
      farms = otherFarms
      break
    case MINTTOKEN.ALLNFT:
      farms = allNftFarms
      break
    case MINTTOKEN.PET:
      farms = petFarms
      break
    case MINTTOKEN.BPET:
      farms = bPetFarms
      break
    case MINTTOKEN.WEAPON:
      farms = weaponFarms
      break
    case MINTTOKEN.SHIELD:
      farms = shieldFarms
      break
    case MINTTOKEN.BEST:
      farms = bestFarms
      break
    case MINTTOKEN.WSOTE:
      farms = wsoteFarms
      break
    case MINTTOKEN.HELMETNFT:
      farms = helmetFarms
      break
    case MINTTOKEN.SEASCAPENFT:
      farms = seascapeNftFarms
      break
    case MINTTOKEN.TKONFT:
      farms = tkoNftFarms
      break
    case MINTTOKEN.HATNFT:
      farms = hatNftFarms
      break
    case MINTTOKEN.ETH2MASTER:
      farms = ethFarms
      break
    case MINTTOKEN.AETHMASTER:
      farms = aethFarms
      break
    case MINTTOKEN.AETHANDETH2:
      farms = aethAndethFarms
      break
    case MINTTOKEN.TEN:
      farms = springFarms
      break
    case MINTTOKEN.BRY:
      farms = bryFarms
      break
    case MINTTOKEN.PCWS:
      farms = pcwsFarms
      break
    case MINTTOKEN.BAKESTAKING:
      farms = bakeStakingFarms
      break
    case MINTTOKEN.DEFI100:
      farms = defi100Farms
      break
    case MINTTOKEN.DEFI100OLD:
      farms = defi100OLDFarms
      break
    case MINTTOKEN.BANANA:
      farms = bananaFarms
      break
    case MINTTOKEN.WAR:
      farms = warFarms
      break
    case MINTTOKEN.WAR2:
      farms = war2Farms
      break
    case MINTTOKEN.DIESEL:
      farms = dieselFarms
      break
    case MINTTOKEN.MX:
      farms = mxFarms
      break
    case MINTTOKEN.ALICE:
      farms = aliceFarms
      break
    case MINTTOKEN.ALICENFT:
      farms = aliceNftFarms
      break
    case MINTTOKEN.BONDLYNFT:
      farms = bondlyNftFarms
      break
    case MINTTOKEN.DFY:
      farms = dfyFarms
      break
    case MINTTOKEN.GFX:
      farms = gfxFarms
      break
    case MINTTOKEN.XDITTO:
      farms = xDittoFarms
      break
    case MINTTOKEN.SACT:
      farms = sactFarms
      break
    case MINTTOKEN.PET3:
      farms = pet3Farms
      break
    case MINTTOKEN.HYFI:
      farms = hyfiFarms
      break
    case MINTTOKEN.GINU:
      farms = ginuFarms
      break
    case MINTTOKEN.LEV:
      farms = levFarms
      break
    case MINTTOKEN.BONDLY:
      farms = bondlyFarms
      break
    case MINTTOKEN.TCT:
      farms = tctFarms
      break
    case MINTTOKEN.TKO:
      farms = tkoFarms
      break
    case MINTTOKEN.TKONFTSTAKE:
      farms = tkonftStakeFarms
      break
    case MINTTOKEN.BMONCNFTSTAKE:
      farms = bmoncnftStakeFarms
      break
    case MINTTOKEN.BMMNFTSTAKE:
      farms = bmmnftStakeFarms
      break
    case MINTTOKEN.TOYNFTSTAKE:
      farms = toynftStakeFarms
      break
    case MINTTOKEN.NFTSTAKE:
      farms = nftStakeFarms
      break
    case MINTTOKEN.ONEINCHBAKENFT:
      farms = oneInchBakeNftFarms
      break
    case MINTTOKEN.TKO2:
      farms = tko2Farms
      break
    case MINTTOKEN.BNRG:
      farms = bnrgFarms
      break
    case MINTTOKEN.TSA:
      farms = tsaFarms
      break
    case MINTTOKEN.TLM:
      farms = tlmFarms
      break
    case MINTTOKEN.XDITTONFT:
      farms = xdittoNftFarms
      break
    case MINTTOKEN.TLM2:
      farms = doggyTlmFarms
      break
    case MINTTOKEN.TLM3:
      farms = barkTlmFarms
      break
    case MINTTOKEN.TLM4:
      farms = tokauTlmFarms
      break
    case MINTTOKEN.BONDLY2:
      farms = bondly2Farms
      break
    case MINTTOKEN.TLM5:
      farms = gatTlmFarms
      break
    case MINTTOKEN.BAKEV2:
      farms = bakeV2Farms
      break
    case MINTTOKEN.WSG:
      farms = wsgFarms
      break
    case MINTTOKEN.DOGO:
      farms = dogoFarms
      break
    case MINTTOKEN.TOYNFT:
      farms = toyNftFarms
      break
    case MINTTOKEN.BETHMASTER:
      farms = bethFarms
      break
    case MINTTOKEN.TOKAU:
      farms = tokauFarms
      break
    case MINTTOKEN.EGG:
      farms = eggFarms
      break
    case MINTTOKEN.KALATA:
      farms = kalataFarms
      break
    case MINTTOKEN.DON:
      farms = donFarms
      break
    case MINTTOKEN.NT:
      farms = ntFarms
      break
    case MINTTOKEN.MONI:
      farms = moniFarms
      break
    case MINTTOKEN.KXA:
      farms = kxaFarms
      break
    case MINTTOKEN.NBL:
      farms = nblFarms
      break
    default:
      farms = bakeFarms
  }
  return [farms]
}

export default useFarms
